export const notificationsPath = '/notifications';
